import * as React from 'react';
import { ChevronDown, SlidersHorizontal } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface FilterToolbarProps {
  /** 始终可见的主筛选(搜索 + 1~2 个关键筛选) */
  primary: React.ReactNode;
  /** 折叠区的次要筛选;不传则不显示「更多筛选」 */
  more?: React.ReactNode;
  /** 当前生效的次要筛选数量,>0 时在「更多筛选」上显示计数徽标 */
  moreCount?: number;
  /** 右侧主操作(新建 / 批量等) */
  actions?: React.ReactNode;
  defaultOpen?: boolean;
}

/**
 * 列表页筛选工具栏:主筛选常驻,次要筛选收进「更多筛选」折叠区,右侧放主操作。
 * 全站列表页共用,保证筛选区的结构与交互一致。
 */
export function FilterToolbar({
  primary,
  more,
  moreCount = 0,
  actions,
  defaultOpen = false,
}: FilterToolbarProps) {
  const [open, setOpen] = React.useState(defaultOpen);

  return (
    <div className="flex shrink-0 flex-col gap-2">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex flex-wrap items-center gap-2">
          {primary}
          {more && (
            <Button variant="outline" className="h-9 gap-1.5" onClick={() => setOpen((v) => !v)}>
              <SlidersHorizontal className="h-4 w-4" />
              更多筛选
              {moreCount > 0 && (
                <Badge variant="secondary" className="ml-0.5 h-5 px-1.5 text-xs">
                  {moreCount}
                </Badge>
              )}
              <ChevronDown className={cn('h-4 w-4 transition-transform', open && 'rotate-180')} />
            </Button>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {more && open && (
        <div className="flex flex-wrap items-center gap-2 rounded-lg border border-border bg-muted/20 p-3">
          {more}
        </div>
      )}
    </div>
  );
}
